import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  CircularProgress,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { updateFoulWord } from "../../../redux/slices/foulWordsSlice";
import { Cancel as CancelIcon } from "@mui/icons-material";
import { orange } from "@mui/material/colors";
import Swal from "sweetalert2";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

const EditFoulWordDialog = ({ open, onClose, word }) => {
  const dispatch = useDispatch();
  const [editedWord, setEditedWord] = useState("");
  const [editLoading, setEditLoading] = useState(false);

  useEffect(() => {
    if (word) {
      setEditedWord(word.foulWord || "");
    }
  }, [word]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (word && editedWord.trim()) {
      setEditLoading(true);
      try {
        await dispatch(updateFoulWord({ wordId: word.id, updatedfoulWord: editedWord })).unwrap();
        onClose();
        await Swal.fire({
          icon: "success",
          title: "Word Updated",
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error("Update failed:", error);
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Some Error Occurred.",
        });
        onClose();
      } finally {
        setEditLoading(false);
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs" disablePortal>
      <DialogTitle>
        Edit Foul Word
        <span
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            padding: "10px",
            cursor: "pointer",
          }}
        >
          <CancelIcon sx={{ color: orange[500] }} onClick={onClose} />
        </span>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin="dense"
            value={editedWord}
            onChange={(e) => setEditedWord(e.target.value)}
            label="Foul Word"
            autoFocus
          />
          <MDButton
            type="submit"
            variant="gradient"
            color="light"
            fullWidth
            style={{ marginTop: "15px" }}
          >
            {editLoading ? (
              <MDBox display="flex" justifyContent="center" alignItems="center" width="100%">
                <CircularProgress sx={{ color: "#ffffff" }} size={24} />
              </MDBox>
            ) : (
              <MDTypography style={{ fontSize: "13.5px", fontWeight: "bold" }} color="white">
                Submit
              </MDTypography>
            )}
          </MDButton>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EditFoulWordDialog;
